import { generatePath } from 'react-router-dom'
import { CUSTOMER_INFO } from 'constants/app-paths'

export const customerInfo = (id) => ([
  {
    label: 'Informações',
    link: generatePath(CUSTOMER_INFO, { id }),
  },
])
